module.exports = __webpack_public_path__ + "static/img/has_been_completed.807193a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/survey/has_been_completed.png
// module id = +3Sl
// module chunks = 1